import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SettingsService } from './settings.service';
import { GetLinkedZoomAccountViewModel } from 'edu-application/dist/zoom-tokens/get-linked-zoom-accounts/get-linked-zoom-accounts.viewmodel';
import { GetSystemConfigViewModel } from 'edu-application/dist/system-config/get-system-config/get-system-config.veiwmodel';
import { OrganizationService } from '../shared/organization.service';

@Component({
  selector: 'edu-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SettingsComponent implements OnInit {
  systemConfig: GetSystemConfigViewModel | null = null;
  orgId!: string;
  isLoadingConfig: boolean = false;

  constructor(
    private settingsService: SettingsService,
    private organizationService: OrganizationService,
  ) {}

  ngOnInit(): void {
    this.orgId = this.organizationService.getOrganizationId();
    this.isLoadingConfig = true;
    this.settingsService.getSystemConfig(this.orgId).subscribe({
      next: (config) => {
        this.systemConfig = config;
        this.isLoadingConfig = false;
      },
      error: () => {
        this.systemConfig = null;
        this.isLoadingConfig = false;
      },
    });
  }
}
